import { defineMessages } from 'react-intl';

export const messages = defineMessages({
  costSummary: {
    defaultMessage: 'Cost summary',
    id: 'h/qREE',
    description: 'Cost summary section header text',
  },
  costOfGoods: {
    defaultMessage: 'Cost of Goods:',
    id: 'c8UMRH',
    description: 'Label for total cost of goods (sum of qty * cost per item)',
  },
  totalCost: {
    defaultMessage: 'Total Cost:',
    id: 'ZnxngD',
    description: 'Label for total cost including shipping, taxes, and tariffs',
  },
});
